import React, { useState } from "react";
import Header2 from "./../Common/Header2";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import emailjs from "emailjs-com";

var bnrimg = require("./../../images/banner/9.jpg");

const ContactUs = () => {
	const [formData, setFormData] = useState({
		username: "",
		phone:"",
		email: "",
		message: "",
	});

	const [loading, setLoading] = useState(false);  // To manage loading state
    const [message, setMessage] = useState("");     // To manage success or error message

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevState) => ({ ...prevState, [name]: value }));
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		// Replace with your EmailJS credentials
		const serviceID = "service_pmgowyl";
		const templateID = "template_c9fcbj6";
		const userID = "tGBADelUw-18cEV5d";

		emailjs
        .send(serviceID, templateID, formData, userID)
        .then(
            (response) => {
				setLoading(false);
				setMessage("Your message has been sent successfully!");

				setTimeout(() => {
					setMessage("");
					setFormData({ username: "", email: "", phone: "", message: "" });
				}, 3000);
            },

            (error) => {
				setLoading(false);
				setMessage("There was an error sending your message. Please try again later.");

				setTimeout(() => {
					setMessage("");
				}, 3000);
            }
        );
	};

	return (
		<>
		<Header2 />
		<div className="page-content">
			<Banner title="Contact Us" pagename="Contact us" description="" bgimage={bnrimg}/>
			<div className="section-full p-tb80 inner-page-padding">
				<div className="container">
					<div className="section-content">
						<div className="row">
							<div className="col-lg-8 col-md-12 col-sm-12">
								{message && <p className={`message ${message.includes("error") ? "error" : ""}`}>{message}</p>}
								<form className="contact-form cons-contact-form bg-gray p-a30" onSubmit={handleSubmit}>
									<div className="contact-one">
										<div className="section-head">
											<div className="sx-separator-outer separator-left">
												<div className="sx-separator bg-white bg-moving bg-repeat-x" >
													<h3 className="sep-line-one">Form</h3>
												</div>
											</div>
										</div>

										<div className="form-group">
											<input
											name="username"
											type="text"
											required
											className="form-control"
											placeholder="Name"
											value={formData.username}
											onChange={handleChange}
											/>
										</div>

										<div className="form-group">
											<input
											name="phone"
											type="tel"
											required
											className="form-control"
											placeholder="Phone"
											value={formData.phone}
											onChange={handleChange}
											/>
										</div>

										<div className="form-group">
											<input
											name="email"
											type="email"
											className="form-control"
											required
											placeholder="Email"
											value={formData.email}
											onChange={handleChange}
											/>
										</div>

										<div className="form-group">
											<textarea
											name="message"
											rows={4}
											className="form-control "
											required
											placeholder="Message"
											value={formData.message}
											onChange={handleChange}
											/>
										</div>
										
										<div className="text-right">
											<button
											type="submit"
											className="site-button btn-half"
											disabled={loading}
											>
											<span> {loading ? "Sending..." : "Send Message"}</span>
											</button>
										</div>
									</div>
								</form>
							</div>

							<div className="col-lg-4 col-md-12 col-sm-12">
								<div className="contact-info block-shadow bg-white bg-center p-a40">
									<div>
										<div className="section-head">
											<div className="sx-separator-outer separator-left">
												<div className="sx-separator bg-white bg-moving bg-repeat-x">
													<h3 className="sep-line-one">Info</h3>
												</div>
											</div>
										</div>
										<div className="sx-icon-box-wraper left p-b30">
											<div className="icon-xs">
											<i className="fa fa-phone" />
											</div>
											<div className="icon-content">
											<h5 className="m-t0">Phone number</h5>
											<p>+91 70031 65967</p>
											</div>
										</div>
										<div className="sx-icon-box-wraper left p-b30">
											<div className="icon-xs">
											<i className="fa fa-envelope" />
											</div>
											<div className="icon-content">
											<h5 className="m-t0">Email address</h5>
											<p>info@madhubancontracts.com</p>
											</div>
										</div>
										<div className="sx-icon-box-wraper left">
											<div className="icon-xs">
											<i className="fa fa-map-marker" />
											</div>
											<div className="icon-content">
											<h5 className="m-t0">Address info</h5>
											<p>6, Santi Pally, BA - 52 Rajdanga Sarat Park, Kolkata - 700 107</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer />
		</>
	);
};

export default ContactUs;
